module.exports = __webpack_public_path__ + "static/media/master-real-estate_new.556e847e.svg";